import React from 'react'

import styled from 'styled-components';
import DashboardBarGraph from './DashboardBarGraph';
import Modal from '@mui/material/Modal';

import BreakdownModal from './BreakdownModal'

const Wrapper = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;

  color: #e0e0e0;
  font-family: "Inter";
  background: #333333;

  align-items: center;
  flex-direction: column;
  padding-top: 5vh;
`

const DashboardBanner = styled.div`
  display: flex;

  width: 90vw;
  height: 80vh;

  flex-wrap: wrap;

  justify-content: space-between;
  gap: 2vw;
`

const DashboardTitle = styled.div`
  width: 100%;
  font-size: 4rem;
  text-align: center;
  color: #6C7A89;
`

const DashboardDepartmentBox = styled.div`
  border: 1px solid #4a4a4a;
  flex: 1 0 calc(50% - 2vw);
  box-sizing: border-box;
  border-radius: 15px;
  padding: 1vw;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: box-shadow 0.3s ease;
  cursor: pointer;

  transition: transform 0.3s ease;
  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
    transform: scale(1.005);
  }

  background: linear-gradient(160deg,#222222 15%, #333333 60%,  #222222);
`;


const DepartmentTitle = styled.div`
  font-size: 2rem;
`

const DepartmentBoxBody = styled.div`
  border-radius: 15px;

  height: calc(90% - 2vw);

  display: flex;
  flex-direction: row;
  gap: 1vw;
`

const GraphBox = styled.div`
  border: 1px solid #4a4a4a;
  border-radius: inherit;
  width: 70%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  
  display: flex;
  justify-content: center;
  align-items: center;

  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  }

`;


const DataBoxContainer = styled.div`
  border-radius: inherit;
  width: 30%;

  display: flex;
  flex-direction: column;
  gap: 1vw;
`

const DataBox = styled.div`
  border: 1px solid #4a4a4a;
  border-radius: inherit;
  height: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  transition: box-shadow 0.3s ease;

  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  flex-direction: column;
`;

const DataTitle = styled.div`
  
`

const DataValue = styled.div`
  font-size: 3rem;
  color: #6C7A89;

  &.threeValues {
    font-size: 2rem;
  }
`

export default function MasterDashboard() {

  const [assignarMonthlyData, setAssignarMonthlyData] = React.useState({});
  const [traffioMonthlyData, setTraffioMonthlyData] = React.useState({});

  const [assignarWeeklyData, setAssignarWeeklyData] = React.useState({});
  const [traffioWeeklyData, setTraffioWeeklyData] = React.useState({});

  function getMondayOfLastWeek() {
    let date = new Date();
    date.setDate(date.getDate() - ((date.getDay() + 6) % 7) - 7);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  const getLastWeekData = async (department) => {

    const weekStart = await getMondayOfLastWeek();

    try {
      const response = await fetch(`https://ic360portalbackend.azurewebsites.net/api/masterDashboard/weeklyData/${department}/${weekStart}`)

      const data = await response.json();
      console.log(data);

      if (department === "Allroad") {
        setAssignarWeeklyData(data);
      } else if (department === "Traffic") {
        setTraffioWeeklyData(data);
      }

    } catch (error) {
      console.error("Error getting weekly data", error)
    }
  }

  const sortDataByMonth = (data) => {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const sortedData = {};
    months.forEach(month => {
      if (data[month]) {
        sortedData[month] = data[month];
      }
    });

    return sortedData;
  }

  const getMonthlyData = async (department) => {
    try {
      const response = await fetch(`https://ic360portalbackend.azurewebsites.net/api/masterDashboard/monthlyData/${department}`);

      const data = await response.json();

      const sortedData = await sortDataByMonth(data);

      if (department === "Allroad") {
        setAssignarMonthlyData(sortedData);
      } else if (department === "Traffic") {
        setTraffioMonthlyData(sortedData);
      }

    } catch (error) {
      console.error("Error getting monthly data", error)
    }
  }


  React.useEffect(() => {
    getMonthlyData("Allroad");
    getMonthlyData("Traffic");

    getLastWeekData("Allroad");
    getLastWeekData("Traffic");
  }, [])

  // Modal Code
  const [open, setOpen] = React.useState(false);
  const handleOpen = async (targetDepartment) => {
    setModalDepartment(targetDepartment)
  };
  const [modalDepartment, setModalDepartment] = React.useState("")
  React.useEffect(()=>{
    if (modalDepartment !== "") {
      setOpen(true);
    }
  }, [modalDepartment])

  const handleClose = () => {
    setOpen(false);
  };

  // clear modalDepartment when the modal is closed
  React.useEffect(() => {
    if (!open) {
      setModalDepartment("");
    }
  }, [open]);

  return (<Wrapper>
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        <BreakdownModal handleClose={handleClose} department={modalDepartment}/>
      </>
      
    </Modal>
    <DashboardTitle>IC360 & ALLROAD CENTRAL DASHBOARD</DashboardTitle>
    <DashboardBanner>
      <DashboardDepartmentBox onClick={()=>{handleOpen("Allroad")}}>
        <DepartmentTitle>ALLROAD</DepartmentTitle>
        <DepartmentBoxBody >
          <GraphBox>
            <DashboardBarGraph monthlyData={assignarMonthlyData} />
          </GraphBox>
          <DataBoxContainer>
            <DataBox >
              <DataValue>{assignarWeeklyData.total_employees}</DataValue>
              <DataTitle>Employees</DataTitle>
            </DataBox>
            <DataBox>
              <DataValue>{assignarWeeklyData.total_hours}</DataValue>
              <DataTitle>Hours</DataTitle>
            </DataBox>
          </DataBoxContainer>
        </DepartmentBoxBody>
      </DashboardDepartmentBox>
      <DashboardDepartmentBox>
        <DepartmentTitle>LABOUR</DepartmentTitle>
        <DepartmentBoxBody>
          <GraphBox>
            <DashboardBarGraph />
          </GraphBox>
          <DataBoxContainer>
            <DataBox>
              <DataValue>-</DataValue>
              <DataTitle>Employees</DataTitle>
            </DataBox>
            <DataBox>
              <DataValue>-</DataValue>
              <DataTitle>Hours</DataTitle>
            </DataBox>
          </DataBoxContainer>
        </DepartmentBoxBody>
      </DashboardDepartmentBox>
      <DashboardDepartmentBox onClick={()=>{handleOpen("Traffic")}}>
        <DepartmentTitle>TRAFFIC</DepartmentTitle>
        <DepartmentBoxBody>
          <GraphBox>
            <DashboardBarGraph monthlyData={traffioMonthlyData} />
          </GraphBox>
          <DataBoxContainer>
            <DataBox>
              <DataValue>{traffioWeeklyData.total_employees}</DataValue>
              <DataTitle>Employees</DataTitle>
            </DataBox>
            <DataBox>
              <DataValue>{traffioWeeklyData.total_hours}</DataValue>
              <DataTitle>Hours</DataTitle>
            </DataBox>
          </DataBoxContainer>
        </DepartmentBoxBody>
      </DashboardDepartmentBox>
      <DashboardDepartmentBox>
        <DepartmentTitle>ENGINEERING</DepartmentTitle>
        <DepartmentBoxBody>
          <GraphBox>
            <DashboardBarGraph />
          </GraphBox>
          <DataBoxContainer>
            <DataBox>
              <DataValue>-</DataValue>
              <DataTitle>Employees</DataTitle>
            </DataBox>
            <DataBox>
              <DataValue>-</DataValue>
              <DataTitle>Hours</DataTitle>
            </DataBox>
          </DataBoxContainer>
        </DepartmentBoxBody>
      </DashboardDepartmentBox>

    </DashboardBanner>
  </Wrapper>)
}
